import React, { useMemo, useState } from 'react';
import { DatePicker } from 'antd';
import BranchList from 'components/BranchList';
import DataGrid, { DataGridColDef } from 'components/DataGrid/DataGrid';
import ParListSelect from 'components/ParListSelect';
import ThirdPartyInput from 'components/ThirdPartyInput';
import DF from 'DisplayFramework';
import OfferInput from 'pages/ProposalV3/PropDetail/OfferInput';
import ProductInput from 'pages/ProposalV3/PropDetail/ProductInput';
import { useQuery } from 'react-query';
import {
  getStatProductionByCriteria,
  GetStatProductionByCriteriaParams,
  StatProductionResponse,
} from 'services/statistics';

const StatisticsProdList = () => {
  const [searchParams, setSearchParams] =
    useState<GetStatProductionByCriteriaParams>({
      assetcategory: '',
      assettype: '',
      brid: 0,
      networkcode: '',
      offerid: 0,
      percodeend: '',
      percodestart: '',
      prcode: '',
      tpidbroker: 0,
    });

  const [searchs, setsearchs] = useState(false);

  const { data, isFetching } = useQuery(
    ['getStatProductionByCriteria', searchParams],
    () =>
      getStatProductionByCriteria(searchParams).then((res) => res.list || []),
    { enabled: searchs }
  );

  const [prcode, setprcode] = useState<string>();
  const [assettype, setassettype] = useState<string>();

  const columns = useMemo<DataGridColDef<StatProductionResponse>[]>(
    () => [
      {
        comcode: 'productlabel',
        dataIndex: 'prcode',
        filtrable: true,
        filterComponent: (
          <ProductInput
            allowClear
            onSelected={(value) => {
              setprcode(value);
            }}
          />
        ),
        render: (value, record) => record.productlabel,
        width: 140,
      },
      {
        comcode: 'offerlabel',
        dataIndex: 'offerid',
        filtrable: true,
        filterComponent: (
          <OfferInput
            params={{
              prcode: prcode,
              filters: '',
              finamount: 0,
              duration: 0,
              searchMode: 'PRCODE',
            }}
            allowClear
          />
        ),
        render: (value, record) => {
          return record.offerlabel;
        },
        width: 200,
      },
      {
        comcode: 'networklabel',
        dataIndex: 'networkcode',
        filtrable: true,
        filterComponent: <ParListSelect parcode="NETWORK" allowClear />,
        render: (value, record) => record.networklabel,
        width: 140,
      },
      {
        dataIndex: 'brid',
        filtrable: true,
        filterComponent: (
          <BranchList
            params={{
              mgid: Number(localStorage.getItem('mgid')),
              channelcode: '',
              brname: '',
            }}
            allowClear
          />
        ),
        width: 140,
      },
      {
        comcode: 'assettypelabel',
        dataIndex: 'assettype',
        filtrable: true,
        filterComponent: (
          <ParListSelect
            parcode="ASSETTYPE"
            onSelected={(val) => setassettype(val)}
            allowClear
          />
        ),
        render: (value, record) => record.assettypelabel,
        width: 100,
      },
      {
        comcode: 'assetcategorylabel',
        dataIndex: 'assetcategory',
        filtrable: true,
        filterComponent: (
          <ParListSelect
            parcode="ASSETCAT"
            parvalueparent={assettype}
            allowClear
          />
        ),
        render: (value, record) => record.assetcategorylabel,
        width: '140px',
      },
      {
        dataIndex: 'assetcat',
        width: 100,
      },
      {
        dataIndex: 'percodestart',
        filtrable: true,
        filterComponent: (
          <DatePicker placeholder="start date" format="YYYYMM" picker="month" />
        ),
        width: 100,
      },
      {
        dataIndex: 'percodeend',
        filtrable: true,
        filterComponent: (
          <DatePicker placeholder="end date" format="YYYYMM" picker="month" />
        ),
        width: 100,
      },
      {
        dataIndex: 'tpidbroker',
        filtrable: true,
        filterComponent: <ThirdPartyInput role="BROKER" />,
        //render: (value, record) => record.brokername,
        width: 100,
      },
      {
        dataIndex: 'canceledcttotalfinancedamount',
        width: 100,
      },
      {
        dataIndex: 'canceledcttotalnumber',
        width: 100,
      },
      {
        dataIndex: 'newcttotalfinancedamount',
        width: 100,
      },
      {
        dataIndex: 'newcttotalfinservamount',
        width: 100,
      },
      {
        dataIndex: 'newcttotalfinservnumber',
        width: 100,
      },
      {
        dataIndex: 'newcttotalnumber',
        width: 100,
      },
      {
        dataIndex: 'newcttotalservnumber',
        width: 100,
      },
      {
        dataIndex: 'newcttotalservicerevenue',
        width: 100,
      },
      {
        dataIndex: 'outstandingtotalfinancedamount',
        width: 100,
      },
      {
        dataIndex: 'outstandingtotalfinservamount',
        width: 100,
      },
      {
        dataIndex: 'percode',
        width: 100,
      },
      {
        dataIndex: 'stockintotalnumber',
        width: 100,
      },
      {
        dataIndex: 'stockintotalrvamount',
        width: 100,
      },
      {
        dataIndex: 'stockoutgainorlossamount',
        width: 100,
      },
      {
        dataIndex: 'stockouttotalnumber',
        width: 100,
      },
      {
        dataIndex: 'stockouttotalsaleamount',
        width: 100,
      },
      {
        dataIndex: 'totalcommissionexpense',
        width: 100,
      },
      {
        dataIndex: 'totalnotinvoicedrvamount',
        width: 100,
      },
      {
        dataIndex: 'totalrentalrevenue',
        width: 100,
      },
      {
        dataIndex: 'totalservicerevenue',
        width: 100,
      },
    ],
    [prcode, assettype]
  );

  return (
    <DF.Provider pagcode="statproductionlist">
      <DataGrid
        columns={columns}
        isLoading={isFetching}
        dataSource={data}
        rowKey="id"
        onSearch={(values) => {
          setSearchParams(values);
          setsearchs(true);
        }}
        initialSearchValues={searchParams}
        extractData="statistics"
        extraActions={<>&nbsp;</>}
      />
    </DF.Provider>
  );
};

export default StatisticsProdList;
